const debounce = require('throttle-debounce/debounce');

const triggerResize = debounce(500, () => {
	$(window).trigger('resize');
});

$('img').imgLoad(triggerResize);



// WEBPACK FOOTER //
// ./temp/components/core/triggerResizeOnImageLoad.js